import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full bg-ink text-white" data-id="element-0" data-mp="31bs1tg4gn1nr">
      <MetaPixel data-id="element-1" data-mp="2wk08wyxu0jug" />
      <main data-id="element-2" data-mp="2wjgrdjc3fxgy">
        <Hero data-id="element-3" data-mp="2wjqff1dkvuk0" />
        <Stats data-id="element-4" data-mp="2wj8ehrfz0s5r" />
        <Testimonials data-id="element-5" data-mp="2wip5j08ate3v" />
        <PainPoints data-id="element-6" data-mp="2wi5m1f302hnq" />
        <Tomos data-id="element-7" data-mp="28tw6guwdqq51" />
        <Bonuses data-id="element-8" data-mp="28tmi1bqzgr1g" />
        <Countdown data-id="element-9" data-mp="28t4j27cxrypu" />
        <Pricing data-id="element-10" data-mp="28sbbj465l56n" />
        <FAQ data-id="element-11" data-mp="23vciyq2516ak" />
        <ValueStack data-id="element-12" data-mp="23vkuadim43jn" />
      </main>
      <Footer data-id="element-13" data-mp="23ujkecdc1n3i" />
    </div>;
}